import React from "react"
import styled from "@emotion/styled"
import { Container } from "theme-ui"

const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    color: ${(props) => props.theme.colors.background};
    padding: 0 7%;
    & .content-title,
    p,
    h2 {
        margin: 0;
    }
    h2 {
        text-align: left !important;
        line-height: 1;
        margin-top: 2rem;
    }
    & .raw-html-embed {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        padding-top: 25px;
        height: 0;

        & iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    & figure.image.image-style-align-left {
        margin-left: 0;
        margin-top: 0.5rem;
    }

    & figure.image.image-style-align-center {
        margin-left: auto;
        margin-right: auto;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 0 10%;
    }
    @media screen and (min-width: ${(props) =>
            props.theme.breakpoints[5]}) and (max-width: 1350px) {
        & figure.image.image-style-align-left {
            width: 55%;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        padding: 0 10%;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[5]}) {
        & .raw-html-embed {
            width: 400px;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 0 0;
        & .raw-html-embed {
            width: 100%;
        }
        & figure.image.image-style-align-left {
            margin-left: 0;
            margin-right: 0;
        }
    }
`

const ContentBox = styled.div`
    background-color: ${(props) => props.theme.colors.background};
    left: 15%;
    z-index: 10;
    color: ${(props) => props.theme.colors.text1};
    bottom: 3rem;
    min-height: 500px;
    height: auto;
    text-align: left;

    & .content-title {
        color: ${(props) => props.theme.colors.primary};
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        & p,
        li,
        .content-paragraph {
            line-height: 1.2;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        // & h2 {
        //     font-size: 35px;
        // }
        // & h3 {
        //     font-size: 30px;
        // }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[5]}) {
        padding: 0 1rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        padding-bottom: 2rem;

        // & h2 {
        //     font-size: 27px;
        // }
        // & h3 {
        //     font-size: 25px;
        // }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        padding-bottom: 2rem;

        // & h2 {
        //     font-size: 17px;
        // }
        // & h3 {
        //     font-size: 15px;
        // }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[1]}) {
        // & h2 {
        //     font-size: 16px;
        // }
        // & h3 {
        //     font-size: 13px;
        // }
    }
`

function Contents({ children }) {
    return (
        <ContentWrapper>
            <Container className="content">
                <ContentBox>{children}</ContentBox>
            </Container>
        </ContentWrapper>
    )
}

export default Contents
